import { CommonModule, DatePipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericPopupComponent } from './components/generic-popup/generic-popup.component.js'
import { ValidationErrorsComponent } from './components/validation-errors.component.js'
import { AutoCardElevationDirective } from './directives/auto-card-elevation.directive.js'
import { ScopeDirective } from './directives/scope.directive.js'
import { Base64SrcPipe } from './pipes/base64-src.pipe.js'
import { SafeHtmlPipe } from './pipes/safe-html.pipe.js'
import { SafeResourceUrlPipe } from './pipes/safe-resource-url.pipe.js'
import { SafeUrlPipe } from './pipes/safe-url.pipe.js'
import { LetDirective } from '@ngrx/component'
import { OverlayModule } from '@angular/cdk/overlay'
import { UntilChangedPipe } from './pipes/until-changed.pipe.js'
import { DynamicTabDirective } from './directives/dynamic-tab.directive.js'
import { ConstPipe } from './pipes/const.pipe.js'
import { JsonHighlightPipe } from './pipes/json-highlight.pipe.js'
import { SnackBarComponent } from './components/snack-bar/snack-bar.component.js'
import { FormFieldDirective } from './directives/form-field.directive.js'
import { MaybeAsyncPipe } from './pipes/maybe-async.pipe.js'
import { GenericTableColumn } from './components/generic-table/generic-table-column.directive.js'
import { TabGroupControlDirective } from './directives/tab-group-control.directive.js'
import { TabGroupTabControlDirective } from './directives/tab-group-tab-control-directive.js'
import { EscapeHtmlPipe } from './pipes/escape-html.pipe.js'
import { ReplaceNewlinesPipe } from './pipes/replace-newlines.pipe.js'
import { TypeSafeMatCellDef } from './directives/typesafe-matcelldef.directive.js'
import { FilterByValuePipe } from './pipes/filter-by-value.pipe.js'
import { HasValidatorErrorPipe } from './pipes/has-validator-error.pipe.js'
import { FormCompomentForObjectDirective } from './directives/form-component-for-object.directive.js'
import { FormControlDestroyDirective } from './directives/form-control-destroy.directive.js'
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe.js'
import { Base64Pipe } from './pipes/base64.pipe.js'
import { ArrayBufferSrcPipe } from './pipes/arraybuffer-src.pipe.js'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { FormDirective } from './directives/form.directive.js'

const Declarations = [
	// Components:
	GenericPopupComponent,
	ValidationErrorsComponent,
	SnackBarComponent,
	// Pipes
	ArrayBufferSrcPipe,
	Base64Pipe,
	Base64SrcPipe,
	ConstPipe,
	EscapeHtmlPipe,
	FilterByValuePipe,
	HasValidatorErrorPipe,
	JsonHighlightPipe,
	MaybeAsyncPipe,
	ReplaceNewlinesPipe,
	SafeHtmlPipe,
	SafeResourceUrlPipe,
	SafeUrlPipe,
	SanitizeHtmlPipe,
	// FormBindingPipe,
	UntilChangedPipe,
	// Directives
	AutoCardElevationDirective,
	DynamicTabDirective,
	FormCompomentForObjectDirective,
	FormControlDestroyDirective,
	FormDirective,
	FormFieldDirective,
	GenericTableColumn,
	ScopeDirective,
	TabGroupControlDirective,
	TabGroupTabControlDirective,
	TypeSafeMatCellDef,
] as const

const ImportExport = [
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	LetDirective,
	OverlayModule,
	DatePipe,
	// Commonly-used Material Modules
	MatIconModule,
	MatInputModule,
	MatSelectModule,
	MatButtonModule,
]

@NgModule({
	imports: [
		// SocketIoModule.forRoot({
		//   url: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
		//   options: {
		//     transports: ['websocket'],
		//   }
		// }),
		...ImportExport,
	],
	declarations: [...Declarations],
	exports: [...Declarations, ...ImportExport],
})
export class NgSharedModule {}
